import dynamic from 'next/dynamic';
import { useContext, useState } from 'react';

import { rem } from '@vimeo/bokeh';
import { SearchField } from '@vimeo/ui/core/search';
import { ViewerContext } from '@vimeo/viewer';

type SearchFieldProps = React.ComponentProps<typeof SearchField>;

const Omnisearch = dynamic(async () => {
  const { Omnisearch } = await import('@vimeo/omnisearch');
  return Omnisearch;
});

export const Search = ({ updateGlobalNavSearchState, withToggle, ...rest }: SearchFieldProps) => {
  const viewer = useContext(ViewerContext);
  /** Fallback to trigger a rerender if state is not managed by parent */
  const [, setIsSearchOpen] = useState(false);

  /** hide search in Nav for logged out simplified site */
  if (!viewer || (viewer.isSimplifiedSite && !viewer.user)) {
    return <></>;
  }

  return (
    <>
      <Omnisearch />
      <SearchField
        updateGlobalNavSearchState={updateGlobalNavSearchState || setIsSearchOpen}
        width="100%"
        maxWidth={rem(480)}
        withToggle={withToggle}
        {...(withToggle && {
          inputStyle: {
            maxWidth: '90vw',
            backgroundColor: 'background',
            borderRadius: 'input-md',
          },
        })}
        {...rest}
      />
    </>
  );
};
